import { useState } from "react";
import { pageTitle } from "../PageTitle";
import HeaderOne from "../Header/HeaderOne";
import FooterOne from "../Footer/FooterOne";
import AiInvoiceBanner from "./../../assets/images/banner/cb.png";
import Architecture from "./../../assets/images/banner/Architecture.png";
// import Brochures from "./../../assets/images/WA_CB.png";
import { Link } from "react-router-dom";

const resultsData = [
  { metric: "Response time", before: "Manual replies", after: "Instant" },
  {
    metric: "Customer queries handled",
    before: "Limited",
    after: "300% increase",
  },
  {
    metric: "Missed enquiries",
    before: "Frequent",
    after: "Reduced significantly",
  },
  {
    metric: "Reply accuracy",
    before: "Manual inconsistency",
    after: "Improved accuracy",
  },
  { metric: "Support efficiency", before: "Slow", after: "80% faster" },
  { metric: "Hours saved monthly", before: "0", after: "60+ hours" },
];

const featureCards = [
  {
    icon: "bi bi-chat-dots-fill",
    title: "Instant Customer Replies",
    desc: "Automatically responds to customer questions on WhatsApp, helping businesses engage faster and more consistently.",
  },
  {
    icon: "bi bi-mic-fill",
    title: "Voice Note Understanding",
    desc: "The chatbot can understand voice notes, making customer support and engagement easier and more natural.",
  },
  {
    icon: "bi bi-image-fill",
    title: "Image & Document Support",
    desc: "Reads screenshots, images, and shared documents to better understand customer queries and provide relevant responses.",
  },
  {
    icon: "bi bi-translate",
    title: "Multilingual Conversations",
    desc: "Supports English, Tamil, Malay, Mandarin, and mixed-language conversations for real customer interactions.",
  },
  {
    icon: "bi bi-cpu-fill",
    title: "AI-Powered Conversation Handling",
    desc: "Understands intent, context, and follow-up questions without depending only on fixed chatbot flows.",
  },
  {
    icon: "bi bi-people-fill",
    title: "Built for Customer Engagement",
    desc: "Suitable for lead handling, support, enquiry management, product guidance, and customer communication workflows.",
  },
];

const faqs = [
  {
    q: "How is this different from normal chatbot platforms?",
    a: "Traditional chatbot platforms often rely on fixed flows and limited responses. Our WhatsApp AI chatbot handles natural conversations, voice notes, images, and follow-up questions with more flexibility and intelligence.",
  },
  {
    q: "Can it connect to our existing systems?",
    a: "Yes. The chatbot can connect to your existing CRM, internal systems, or business workflows through API integration.",
  },
  {
    q: "What type of customer queries can it handle?",
    a: "It can handle enquiries, FAQs, product information, service requests, lead qualification, and customer support conversations depending on your business workflow.",
  },
  {
    q: "Can it support multiple languages?",
    a: "Yes. It supports multilingual conversations including English, Tamil, Malay, Mandarin, and mixed-language customer messages.",
  },
  {
    q: "Can it reduce manual customer support effort?",
    a: "Yes. It automates repetitive customer conversations, improves response speed, and helps teams reduce manual workload.",
  },
  {
    q: "Who is this solution suitable for?",
    a: "It is ideal for businesses looking to automate customer engagement, improve response times, and provide scalable WhatsApp-based support.",
  },
];

const Wa_CB = () => {
  pageTitle("WhatsApp Chatbot");

  const [openIndex, setOpenIndex] = useState(0);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };
  const handleWhatsAppClick = () => {
    const phoneNumber = "6590059743"; // WhatsApp number (no '+' or spaces)
    const message = "Hello! I would like to know more about your services.";
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  return (
    <>
      <HeaderOne />

      <div
        className="ai-overlay-wrapper-solutions"
        style={{ backgroundImage: `url(${AiInvoiceBanner})` }}
      >
        <div className="ai-overlay">
          <div className="ai-overlay-center-project-text-solutions">
            <h2 className="ai-overlay-project">
              AI-Powered <br /> WhatsApp Chatbot
            </h2>
          </div>
          <div className="siw-hero-price-box-sol">
            <h3>From SGD 100/month</h3>

            <button
              onClick={handleWhatsAppClick}
              className="theme-btn theme-btn-one siw-hero-small-btn"
            >
              Start a Free Trial
            </button>
          </div>
        </div>
      </div>

      <section className="py-3 py-md-4">
        <div className="container">
          <div className="row g-4 align-items-stretch">
            <div className="col-lg-7 d-flex">
              <div className="food-grey-box w-100">
                <h3 className="siw-project-heading pb-1">
                  Built for real-time customer conversations
                </h3>
                <p className="mb-0 siw-rpa-desc">
                  Most customer support chatbots fail when people ask questions
                  naturally. Customers send short messages, follow-up questions,
                  voice notes, screenshots, and multilingual queries in many
                  different ways. Our WhatsApp AI chatbot is built to understand
                  these real-world conversation patterns. It helps businesses
                  respond faster, more accurately, and with less manual effort.
                </p>
                <p className="siw-rpa-desc">
                  It works based on your actual business workflow and knowledge
                  base. The system can understand customer intent, product
                  questions, service enquiries, and repeated follow-up messages
                  more naturally. It can process text, audio, images, and shared
                  documents more smoothly. This creates a faster and easier
                  experience for your customers while improving support
                  efficiency for your team.
                </p>
              </div>
            </div>

            <div className="col-lg-5 d-flex">
              <div className="siw-project-video-wrapper">
                <iframe
                  className="siw-project-video"
                  src="https://www.youtube.com/embed/_m5HG3zc5us?si=5Zv5t8qfyD08_8ql"
                  title="WhatsApp Chatbot Video"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-3 pt-md-0 pb-md-5 wafod-features-section">
        <div className="container">
          <h3 className="wafod-section-heading">Architecture</h3>
          <img
            src={Architecture}
            alt="Architecture"
            className="img-fluid mb-4"
            height="200"
          />
          <div className="mb-5">
            <h3 className="wafod-section-heading">Key Features</h3>
          </div>

          <div className="row g-4">
            {featureCards.map((item, index) => (
              <div className="col-md-6 col-lg-4" key={index}>
                <div className="food-feature-card wafod-feature-card h-100">
                  <div className="food-feature-icon wafod-feature-icon">
                    <i className={item.icon}></i>
                  </div>
                  <h5 className="wafod-card-title">{item.title}</h5>
                  <p className="mb-0 wafod-card-text">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-3 py-md-5 wafod-results-section">
        <div className="container">
          <div className="mb-4">
            <h3 className="wafod-section-heading-light pb-1">
              Business Impact
            </h3>
          </div>

          <div className="siw-subscription-table-wrap">
            <table className="siw-subscription-table">
              <thead>
                <tr>
                  <th>Metric</th>
                  <th>Before</th>
                  <th>After</th>
                </tr>
              </thead>

              <tbody>
                {resultsData.map((row, index) => (
                  <tr key={index}>
                    <td>{row.metric}</td>
                    <td>{row.before}</td>
                    <td>{row.after}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section className="pt-3 pb-2 py-md-4 wafod-faq-section">
        <div className="container">
          <div className="mb-5">
            <h3 className="wafod-section-heading">Common Questions</h3>
          </div>

          <div className="accordion wafod-accordion">
            {faqs.map((item, index) => (
              <div
                className="accordion-item food-accordion-item wafod-accordion-item mb-3"
                key={index}
              >
                <h2 className="accordion-header wafod-accordion-header">
                  <button
                    type="button"
                    className={`accordion-button food-accordion-btn wafod-accordion-btn ${
                      openIndex !== index ? "collapsed" : ""
                    }`}
                    onClick={() => toggleAccordion(index)}
                    aria-expanded={openIndex === index}
                  >
                    {item.q}
                  </button>
                </h2>

                <div
                  className={`accordion-collapse collapse ${
                    openIndex === index ? "show" : ""
                  }`}
                >
                  <div className="accordion-body wafod-accordion-body">
                    {item.a}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <FooterOne />
    </>
  );
};

export default Wa_CB;
